import { RouteDefinition } from '../shared/navigation/route-definition';
import { RoutePaths } from '../shared/navigation/route-paths';
import { AlwaysShowRouteResolver } from '../shared/navigation/always-show-route-resolver';

export class IntegrationsRouteDefinition {
  public static getRoutes(): RouteDefinition {
    return {
      path: RoutePaths.INTEGRATIONS,
      title: 'navigationIntegrations',
      icon: 'icon-integrations.svg',
      position: 11,
      resolver: AlwaysShowRouteResolver
    };
  }
}
